import { Component } from '@angular/core';
import { MessageService, ThemeService } from '@nsinova/comum';

@Component({
  selector: 'nx-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    themeService: ThemeService,
    messageService: MessageService,
  ) {
    themeService.themeMode = 'light';
    messageService.registryAlert();
  }
}
